module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_305588.8aaec7b0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetAlTFF/FormatoSimplificado_305588.pdf
// module id = 816
// module chunks = 0